var _defs, _g, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShipTaxiWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3f8ff;\n      }\n\n      .cls-2 {\n        fill: #301d29;\n      }\n\n      .cls-3 {\n        fill: #3f2738;\n      }\n\n      .cls-4 {\n        fill: #33222e;\n      }\n\n      .cls-5 {\n        fill: #4c3547;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "180.91 320.68 406.61 329.24 568.93 366.54 137.72 382.3 180.91 320.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "180.91 320.68 344.95 297.25 406.61 329.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "148.72 394.5 554.86 394.5 568.93 366.54 137.47 381.84 148.72 394.5"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "464.4 409.39 542.74 409.39 555.11 394.96 452.03 394.96 464.4 409.39"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "161.19 409.1 239.52 409.1 251.89 394.67 148.82 394.67 161.19 409.1"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "333.93 374.9 569.18 367 406.86 329.69 374.19 351.31 333.93 374.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShipTaxiWhite);
export default __webpack_public_path__ + "static/media/bg-ship-taxi-white.4e46b6b18b14a8628b80cffbcb52b93b.svg";
export { ForwardRef as ReactComponent };